import { Id, IMetadata } from '@/shared/types/builtInTypes'

export enum CashOutStatus {
  APPROVED = 'approved',
  REJECTED = 'rejected',
  CANCELED = 'cancelled',
  PENDING = 'pending',
  AWAITING_ADMIN = 'awaiting_admin'
}

export const cashOutStatusColors: Record<CashOutStatus | string, string> = {
  [CashOutStatus.REJECTED]: 'error',
  [CashOutStatus.APPROVED]: 'success',
  [CashOutStatus.CANCELED]: 'error',
  [CashOutStatus.PENDING]: 'warning',
  [CashOutStatus.AWAITING_ADMIN]: 'info'
}

export interface ICashOutOrder extends IMetadata {
  id: Id
  invoiceNumber: string
  merchantId: Id
  merchant: {
    id: Id
    fullName: string
  }
  reviewedAt: string
  reviewedBy: string
  cashoutStatus: string
  status: CashOutStatus
  orderItems: ICashOutOrderTable[]
  orderItemIds?: Id[]
  orderIds?: Id[]
  notes?: string
}

interface IImage {
  id: Id
  image: string
}

export interface IProductVariantOptions {
  value: string
  name: string
}

export interface ICashOutOrderTable {
  id: Id
  productName: string
  images: IImage[]
  productVariantOptions: IProductVariantOptions[]
  quantity: number
  unitPrice: number
  totalAmount: number

  [key: string]: string | number | IImage[] | IProductVariantOptions[]
}
